import type { ImportRow } from "./itemImport.api";

export function importRowStatus(row: ImportRow): { label: string; className: string } {
  if (row.completed) return { label: "완료", className: "text-bg-success" };
  if (row.duplicate) return { label: "중복", className: "text-bg-danger" };
  if (row.over_limit) return { label: "초과", className: "bg-warning text-warning" };
  if (row.shop_item_gid) return { label: "등록대기", className: "text-bg-primary" };
  return { label: "미확인", className: "" };
}

export function importRowErrorMessage(row: ImportRow): string {
  return [
    ...Object.values(row.errors).flat(),
    row.lookup_error,
    row.check_error,
    row.create_error,
  ].filter(Boolean).join("\n");
}

export function hasImportRegistrationError(row: ImportRow): boolean {
  return !row.completed && Boolean(row.create_error);
}
